var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleChromeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_277_2975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9621 53.9591C45.848 53.9591 53.8637 45.9449 53.8637 36.0576C53.8637 26.1702 45.8495 18.156 35.9621 18.156C26.0748 18.156 18.0605 26.1702 18.0605 36.0576C18.0605 45.9449 26.0748 53.9591 35.9621 53.9591Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.458 45.0113L4.95828 18.1646C1.81531 23.6067 0.160156 29.7802 0.160156 36.0647C0.160156 42.3492 1.81391 48.5227 4.95687 53.9649C8.09984 59.407 12.6195 63.9253 18.0631 67.0669C23.5067 70.2085 29.6802 71.8608 35.9647 71.8594L51.4644 45.0113V45.007C49.895 47.7295 47.6352 49.9908 44.9141 51.563C42.193 53.1352 39.1063 53.9635 35.9633 53.9635C32.8203 53.9635 29.7336 53.1366 27.0111 51.5658C24.2886 49.995 22.0287 47.7338 20.458 45.0113Z",
    fill: "url(#paint0_linear_277_2975)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4637 45.0113L35.9641 71.858C42.2486 71.8594 48.422 70.2057 53.8642 67.0627C59.3064 63.9211 63.8261 59.4014 66.9677 53.9592C70.1092 48.5171 71.763 42.3422 71.7616 36.0577C71.7602 29.7732 70.105 23.5997 66.9606 18.1589H35.9612L35.957 18.1617C39.1 18.1603 42.1881 18.9858 44.9092 20.5566C47.6317 22.1274 49.8916 24.3872 51.4637 27.1083C53.0359 29.8294 53.8628 32.9175 53.8628 36.0605C53.8642 39.2021 53.0359 42.2888 51.4637 45.0113Z",
    fill: "url(#paint1_linear_277_2975)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9613 50.2326C43.7884 50.2326 50.1334 43.8876 50.1334 36.0604C50.1334 28.2332 43.7884 21.8882 35.9613 21.8882C28.1341 21.8882 21.7891 28.2332 21.7891 36.0604C21.7891 43.8876 28.1341 50.2326 35.9613 50.2326Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9626 18.1604H66.9634C63.8218 12.7168 59.3021 8.19707 53.8599 5.05551C48.4177 1.91254 42.2443 0.258789 35.9598 0.258789C29.6752 0.258789 23.5018 1.91394 18.0596 5.05691C12.6174 8.19988 8.09914 12.721 4.95898 18.1632L20.4587 45.0113L20.4629 45.0141C18.8907 42.293 18.061 39.2063 18.061 36.0633C18.061 32.9203 18.8865 29.8322 20.4573 27.1111C22.028 24.3886 24.2879 22.1288 27.0104 20.558C29.7315 18.9858 32.8196 18.1589 35.9626 18.1604Z",
    fill: "url(#paint2_linear_277_2975)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_277_2975",
    x1: 39.8368,
    y1: 69.6233,
    x2: 8.83481,
    y2: 15.9262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E8E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34A853"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_277_2975",
    x1: 30.7399,
    y1: 71.9532,
    x2: 61.7419,
    y2: 18.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBC04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_277_2975",
    x1: 4.9588,
    y1: 22.6364,
    x2: 66.9629,
    y2: 22.6364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D93025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA4335"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_277_2975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleChromeIcon);
export default __webpack_public_path__ + "static/media/google-chrome-icon.7a0cbaec1167cca2ce16454d7d35f018.svg";
export { ForwardRef as ReactComponent };